import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

import parentStyles from './RecoverPasswordPage.module.scss';
import styles from './RecoverPasswordSuccess.module.scss';

export function RecoverPasswordSuccess() {
  const [searchParams] = useSearchParams();

  const unverifiedEmail = searchParams.get('unverified') === 'true';

  if (unverifiedEmail) {
    return (
      <div className={styles.content}>
        <h1 className={parentStyles.title}>
          <FormattedMessage
            id="recover-password-page.success-title-unverified"
            defaultMessage="Verify your email to complete password recovery"
          />
        </h1>
        <p>
          <FormattedMessage
            id="recover-password-page.success-message-unverified"
            defaultMessage="Please check your email inbox and follow the instructions to verify your email and set your new password."
          />
        </p>
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <h1 className={parentStyles.title}>
        <FormattedMessage
          id="recover-password-page.success-title"
          defaultMessage="Your password has been updated"
        />
      </h1>
      <p>
        <FormattedMessage
          id="recover-password-page.success-message"
          defaultMessage="You can now sign in with your new password in the Allurion mobile app."
        />
      </p>
    </div>
  );
}
